import useRequest, { IDataRequest, IJustificativaRequest } from '@hooks/useRequest';
import { EnumDespesaStatus, IDespesa } from '@model/Despesa';
import { IEnum, TDate } from '@utils/TypeHelpers';
import React from 'react';

export interface IDespesaFilter {
    despesaId?: number,
    empresaId?: number,
    descricao?: string,
    competenciaReferencia?: string,
    status?: EnumDespesaStatus
}

export interface IDespesaRegistrar {
    empresaId: number
    descricao: string
    dataReferencia: TDate
    valor: number
}

export interface IDespesaRegistrarRecibo extends IDespesaRegistrar {
    referencia: string
}

export interface IDespesaEditar {
    empresaId: number
    descricao: string
    valor: number
}

export interface IDespesaSummary {
    count: number,
    sumValor: number
}

export interface IDespesaRecibo {
    valor: number
    empresaNome: string
    empresaCnpj: string
    valorExtenso: string
    cidade: string
    dia: string
    mesExtenso: string
    ano: string
    referencia: string
}

const controller = '/Despesa';

export function useDespesaService () {
    const _request = useRequest();

    const listar = React.useCallback((request: IDataRequest<IDespesaFilter>) => {
        return _request.getData<IDespesa[]>(`${controller}/Listar`, request);
    }, [_request]);

    const obterSumario = React.useCallback((request: IDataRequest<IDespesaFilter>) => {
        return _request.get<IDespesaSummary>(`${controller}/ObterSumario`, {
            params: request
        });
    }, [_request]);

    const registrar = React.useCallback((request: IDespesaRegistrar) => {
        return _request.post<IDespesa>(`${controller}/Registrar`, request);
    }, [_request]);

    const registrarRecibo = React.useCallback((request: IDespesaRegistrarRecibo) => {
        return _request.post<IDespesa>(`${controller}/RegistrarRecibo`, request);
    }, [_request]);

    const cancelar = React.useCallback((despesaId: number, request: IJustificativaRequest) => {
        return _request.post<IDespesa>(`${controller}/Cancelar/${despesaId}`, request);
    }, [_request]);

    const listarStatus = React.useCallback(() => {
        return _request.get<IEnum<EnumDespesaStatus>[]>(`${controller}/listarStatus`);
    }, [_request]);

    const obterRecibo = React.useCallback((despesaId: number) => {
        return _request.get<IDespesaRecibo>(`${controller}/ObterRecibo/${despesaId}`);
    }, [_request]);

    return React.useMemo(() => ({
        listar, registrar, cancelar, listarStatus, obterSumario, obterRecibo, registrarRecibo
    }), [listar, registrar, cancelar, listarStatus, obterSumario, obterRecibo, registrarRecibo]);
}